export function isDisabled(api_role, payment_tokens) {
  if (api_role === 'app-admin') {
    return false
  }

  let cardsCount = (payment_tokens || []).filter(
    ({ type }) => type === 'card'
  ).length
  return cardsCount < 2
}
